import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";
import styled, {css} from "@yb/styled-px2rem";

const SearchIcon = styled.i<{icon: string}>`
	display: block;
	width: 20px;
	height: 20px;
	background-image: url(${SpriteImage});
	background-size: 300px 300px;

	${props => {
		if (props.icon === "calendar") {
			return css`
				width: 16px;
				background-position: -20px -78px;
			`;
		}
		if (props.icon === "member") {
			return css`
				background-position: -40px -78px;
			`;
		}
		if (props.icon === "map") {
			return css`
				background-position: 0px -78px;
			`;
		}
		if (props.icon === "search") {
			return css`
				width: 21px;
				height: 21px;
				margin-left: 5px;
				background-position: 0px -16px;
				background-size: 300px 300px;
			`;
		}
	}}
`;

export default SearchIcon;
